import React from "react";

interface AimTargetPreviewProps {
    offsetY: number; // от 0.10 до 0.40
}

const AimIndicator: React.FC<AimTargetPreviewProps> = ({ offsetY }) => {
    const containerHeight = 300; // px, высота блока

    // Ключевые точки по параметру и по высоте (в px)
    const keyPoints = {
        legs: { value: 0.10, px: 280 },
        body: { value: 0.17, px: 180 },
        head: { value: 0.35, px: 60 },
    };

    const getTopPx = (val: number) => {
        if (val <= keyPoints.legs.value) return keyPoints.legs.px;
        if (val > keyPoints.legs.value && val < keyPoints.body.value) {
            const ratio = (val - keyPoints.legs.value) / (keyPoints.body.value - keyPoints.legs.value);
            return keyPoints.legs.px - ratio * (keyPoints.legs.px - keyPoints.body.px);
        }
        if (val >= keyPoints.body.value && val < keyPoints.head.value) {
            const ratio = (val - keyPoints.body.value) / (keyPoints.head.value - keyPoints.body.value);
            return keyPoints.body.px - ratio * (keyPoints.body.px - keyPoints.head.px);
        }
        if (val >= keyPoints.head.value) return keyPoints.head.px;
        return keyPoints.legs.px;
    };

    const topPx = getTopPx(offsetY);

    return (
        <div
            className="relative w-32 rounded-md border border-[#0f4c81] shadow-[0_0_15px_#0a70d9cc] ml-10"
            style={{
                height: containerHeight,
                background:
                    "linear-gradient(180deg, #010b18 0%, #041832 70%, #0c1e3a 100%)",
                boxShadow: "0 0 20px #0a70d9cc inset",
            }}
        >
            {/* Человечек: */}
            <svg
                viewBox="0 0 100 300"
                className="absolute inset-0 w-full h-full"
                preserveAspectRatio="xMidYMid meet"
            >
                {/* Голова с градиентом и свечением */}
                <defs>
                    <radialGradient id="headGradient" cx="50%" cy="50%" r="50%">
                        <stop offset="0%" stopColor="#0a70d9" />
                        <stop offset="100%" stopColor="#082e63" />
                    </radialGradient>
                    <filter id="glow" x="-50%" y="-50%" width="200%" height="200%" >
                        <feDropShadow dx="0" dy="0" stdDeviation="3" floodColor="#0a70d9" floodOpacity="0.7" />
                    </filter>
                </defs>
                <circle cx="50" cy="60" r="25" fill="url(#headGradient)" filter="url(#glow)" />
                {/* Тело с градиентом */}
                <linearGradient id="bodyGradient" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#144ea1" />
                    <stop offset="100%" stopColor="#0a3a75" />
                </linearGradient>
                <rect
                    x="30"
                    y="100"
                    width="40"
                    height="140"
                    rx="15"
                    fill="url(#bodyGradient)"
                    filter="url(#glow)"
                />
                {/* Ноги */}
                <rect
                    x="25"
                    y="240"
                    width="20"
                    height="90"
                    rx="10"
                    fill="#0a56b8"
                    filter="url(#glow)"
                />
                <rect
                    x="55"
                    y="240"
                    width="20"
                    height="90"
                    rx="10"
                    fill="#0a56b8"
                    filter="url(#glow)"
                />
            </svg>

            {/* Линия прицела */}
            <div
                className="absolute left-0 w-full"
                style={{
                    top: topPx,
                    // Неоновый синий glow
                    boxShadow: "0 0 8px 2px #0a70d9",
                }}
            >
                <div
                    className="w-full h-1"
                    style={{
                        background:
                            "linear-gradient(90deg, rgba(10,112,217,1) 0%, rgba(0,200,255,1) 50%, rgba(10,112,217,1) 100%)",
                    }}
                />
            </div>

            {/* Метки */}
            {["head", "body", "legs"].map((part) => (
                <div
                    key={part}
                    className="absolute left-1 text-xs select-none"
                    style={{
                        top: keyPoints[part as keyof typeof keyPoints].px,
                        transform: "translateY(-50%)",
                        color: "#49aaff",
                        textShadow:
                            "0 0 4px #1e3f66, 0 0 10px #0a70d9, 0 0 6px #39a0ff",
                        fontWeight: "600",
                        fontFamily: "'Orbitron', sans-serif",
                    }}
                >
                    {part.charAt(0).toUpperCase() + part.slice(1)} (
                    {keyPoints[part as keyof typeof keyPoints].value.toFixed(2)})
                </div>
            ))}
        </div>
    );
};

export default AimIndicator;
